import { ButtonGroup, Col, Row } from 'react-bootstrap';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ButtonWithIcon } from '../UIExtentions/Buttons';
import { Permission as PermissionString } from '../../permissions/permission';
import React, { useCallback, useEffect } from 'react';
import { ScopedUserPrincipal } from '../../permissions/ScopedUserPrincipal';

interface LinuxServicesServerManagementButtonsProps {
    selectedServers: string[];
    userPrincipal: UserPrincipal;
    serversUserPrincipal: ScopedUserPrincipal;
    onClickCallback: Function;
}
// big buttons
export const LinuxServicesServerManagementButtons = ({ selectedServers, userPrincipal, serversUserPrincipal, onClickCallback }: LinuxServicesServerManagementButtonsProps) => {
    const getEnableState = useCallback(
        function (permission: PermissionString): boolean {
            return !!selectedServers.length && (userPrincipal.hasPermission(permission) || serversUserPrincipal?.hasPermission(selectedServers, permission));
        },
        [selectedServers, serversUserPrincipal, userPrincipal]
    );

    const [canStart, setCanStart] = React.useState(getEnableState(PermissionString.LinuxService_Start));
    const [canStop, setCanStop] = React.useState(getEnableState(PermissionString.LinuxService_Stop));
    const [canRestart, setCanRestart] = React.useState(getEnableState(PermissionString.LinuxService_Restart));
    const [canRefresh, setCanRefresh] = React.useState(getEnableState(PermissionString.LinuxService_Refresh));

    const UpdatePermissions = useCallback(() => {
        setCanStart(getEnableState(PermissionString.LinuxService_Start));
        setCanStop(getEnableState(PermissionString.LinuxService_Stop));
        setCanRestart(getEnableState(PermissionString.LinuxService_Restart));
        setCanRefresh(getEnableState(PermissionString.LinuxService_Refresh));
    }, [getEnableState]);

    useEffect(() => {
        UpdatePermissions();
    }, [selectedServers, userPrincipal, serversUserPrincipal, UpdatePermissions]);

    return (
        <Row style={{ marginBottom: '5px' }}>
            <Col>
                <ButtonGroup style={{ width: '100%' }}>
                    <ButtonWithIcon
                        disabled={!canStart}
                        variant="green"
                        icon="fa-play-circle"
                        textColor="white"
                        text="Start"
                        onClick={async () => await onClickCallback('start', undefined)}
                    />
                    <ButtonWithIcon
                        disabled={!canStop}
                        variant="red"
                        icon="fa-stop-circle"
                        textColor="white"
                        text="Stop"
                        onClick={async () => await onClickCallback('stop', undefined)}
                    />
                    <ButtonWithIcon
                        disabled={!canRestart}
                        variant="blue"
                        icon="fa-step-forward"
                        textColor="white"
                        text="Restart"
                        onClick={async () => await onClickCallback('restart', undefined)}
                    />
                </ButtonGroup>
            </Col>
            <Col>
                <ButtonGroup style={{ width: '100%' }}>
                    <ButtonWithIcon
                        disabled={!canRefresh}
                        variant="dark-blue"
                        icon="fa-refresh"
                        textColor="white"
                        text="Refresh"
                        onClick={async () => await onClickCallback('refresh', undefined)}
                    />
                </ButtonGroup>
            </Col>
        </Row>
    );
};
